import React from "react";
import Layout from "./Layout";
import { Switch, Route } from "react-router-dom";
 
// components
import EcosystemSettings from "./ecosystemSettings";
import Ecosystems from "./ecosystems";
import Integration from "./integration";
import Digitization from "./digitization";
import DataSync from "./dataSync";
import DailyOperations from "./dailyOperations";
import ESDA from "./ESDA";

const Settings = () => {
  return (
    <Layout>
      <Switch>
        <Route
          exact
          path="/schrockenAdmin/settings/ecosystemsettings"
          component={EcosystemSettings}
        />
        <Route
          exact
          path="/schrockenAdmin/settings/ecosystems"
          component={Ecosystems}
        />
        <Route
          exact
          path="/schrockenAdmin/settings/integration"
          component={Integration}
        />
        <Route
          exact
          path="/schrockenAdmin/settings/digitization"
          component={Digitization}
        />
        <Route
          exact
          path="/schrockenAdmin/settings/datasync"
          component={DataSync}
        />
        <Route
          exact
          path="/schrockenAdmin/settings/dailyOperations"
          component={DailyOperations}
        />
        <Route
          exact
          path="/schrockenAdmin/settings/ESDA"
          component={ESDA}
        />
      </Switch>
    </Layout>
  );
};

export default Settings;
